var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "form-horizontal",
      attrs: { action: "#" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.validateForm($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "form-group",
          class: { "has-error": _vm.errors.first("name") }
        },
        [
          _c(
            "label",
            {
              staticClass: "col-sm-3 control-label",
              attrs: { for: "partner-name" }
            },
            [_vm._v("Name")]
          ),
          _c("div", { staticClass: "col-sm-9" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.name,
                  expression: "form.name"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|min:2|max:191",
                  expression: "'required|min:2|max:191'"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                id: "partner-name",
                name: "name",
                autocomplete: "off"
              },
              domProps: { value: _vm.form.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "name", $event.target.value)
                }
              }
            })
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("name"),
                  expression: "errors.has('name')"
                }
              ],
              staticClass: "col-sm-9 col-sm-offset-3 help-block is-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("name")) + " ")]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "form-group",
          class: { "has-error": _vm.errors.first("slug") }
        },
        [
          _c(
            "label",
            {
              staticClass: "col-sm-3 control-label",
              attrs: { for: "partner-slug" }
            },
            [_vm._v("Slug")]
          ),
          _c("div", { staticClass: "col-sm-9" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.slug,
                  expression: "form.slug"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { regex: /^[a-z0-9]+(?:-[a-z0-9]+)*$/, max: 191 },
                  expression:
                    "{ regex: /^[a-z0-9]+(?:-[a-z0-9]+)*$/, max: 191 }"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                id: "partner-slug",
                name: "slug",
                autocomplete: "off",
                placeholder: _vm.slugPlaceholder
              },
              domProps: { value: _vm.form.slug },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "slug", $event.target.value)
                }
              }
            })
          ]),
          !_vm.form.slug && _vm.form.name
            ? _c(
                "div",
                {
                  staticClass: "col-sm-9 col-sm-offset-3 help-block text-muted"
                },
                [
                  _vm._v(
                    " Will be generated as: " +
                      _vm._s(_vm.slugPlaceholder) +
                      " "
                  )
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("slug"),
                  expression: "errors.has('slug')"
                }
              ],
              staticClass: "col-sm-9 col-sm-offset-3 help-block is-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("slug")) + " ")]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "form-group",
          class: { "has-error": _vm.errors.first("category") }
        },
        [
          _c(
            "label",
            {
              staticClass: "col-sm-3 control-label",
              attrs: { for: "partner-category" }
            },
            [_vm._v("Category")]
          ),
          _c("div", { staticClass: "col-sm-9" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.category,
                    expression: "form.category"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "partner-category", name: "category" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.form,
                      "category",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              _vm._l(_vm.categoryOptions, function(cat) {
                return _c(
                  "option",
                  { key: cat.value, domProps: { value: cat.value } },
                  [_vm._v(_vm._s(cat.label))]
                )
              }),
              0
            )
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("category"),
                  expression: "errors.has('category')"
                }
              ],
              staticClass: "col-sm-9 col-sm-offset-3 help-block is-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("category")) + " ")]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "form-group",
          class: { "has-error": _vm.errors.first("links_to") }
        },
        [
          _c("label", { staticClass: "col-sm-3 control-label" }, [
            _vm._v("Links To")
          ]),
          _c(
            "div",
            { staticClass: "col-sm-9" },
            [
              _vm._l(_vm.linksToOptions, function(option) {
                return _c(
                  "label",
                  { key: option.value, staticClass: "checkbox-inline" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.links_to,
                          expression: "form.links_to"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        value: option.value,
                        checked: Array.isArray(_vm.form.links_to)
                          ? _vm._i(_vm.form.links_to, option.value) > -1
                          : _vm.form.links_to
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.form.links_to,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = option.value,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form,
                                  "links_to",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "links_to",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "links_to", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" " + _vm._s(option.label) + " ")
                  ]
                )
              }),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.linksToValidation,
                    expression: "linksToValidation"
                  }
                ],
                attrs: { type: "hidden", name: "links_to" },
                domProps: { value: _vm.linksToValidation },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.linksToValidation = $event.target.value
                  }
                }
              })
            ],
            2
          ),
          _vm.form.links_to.includes("reader")
            ? _c(
                "div",
                {
                  staticClass:
                    "col-sm-9 col-sm-offset-3 help-block text-warning"
                },
                [
                  _c("i", { staticClass: "fa fa-warning" }),
                  _vm._v(
                    " Partner linking directly to children is currently unsupported. "
                  )
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("links_to"),
                  expression: "errors.has('links_to')"
                }
              ],
              staticClass: "col-sm-9 col-sm-offset-3 help-block is-danger"
            },
            [_vm._v(" At least one link type is required ")]
          )
        ]
      ),
      !_vm.form.parent_id
        ? _c(
            "div",
            {
              staticClass: "form-group",
              class: { "has-error": _vm.errors.first("contact_email") }
            },
            [
              _c(
                "label",
                {
                  staticClass: "col-sm-3 control-label",
                  attrs: { for: "partner-email" }
                },
                [_vm._v("Contact Email")]
              ),
              _c("div", { staticClass: "col-sm-9" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.contact_email,
                      expression: "form.contact_email"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "email|max:191",
                      expression: "'email|max:191'"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "email",
                    id: "partner-email",
                    name: "contact_email",
                    autocomplete: "off"
                  },
                  domProps: { value: _vm.form.contact_email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "contact_email", $event.target.value)
                    }
                  }
                })
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("contact_email"),
                      expression: "errors.has('contact_email')"
                    }
                  ],
                  staticClass: "col-sm-9 col-sm-offset-3 help-block is-danger"
                },
                [_vm._v(" " + _vm._s(_vm.errors.first("contact_email")) + " ")]
              )
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "form-group",
          class: { "has-error": _vm.errors.first("website") }
        },
        [
          _c(
            "label",
            {
              staticClass: "col-sm-3 control-label",
              attrs: { for: "partner-website" }
            },
            [_vm._v("Website")]
          ),
          _c("div", { staticClass: "col-sm-9" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.website,
                  expression: "form.website"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "url|max:191",
                  expression: "'url|max:191'"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "url",
                id: "partner-website",
                name: "website",
                autocomplete: "off",
                placeholder: "https://example.com/"
              },
              domProps: { value: _vm.form.website },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "website", $event.target.value)
                }
              }
            })
          ]),
          _c(
            "div",
            { staticClass: "col-sm-9 col-sm-offset-3 help-block text-muted" },
            [
              _vm._v(
                " Where users are sent when they click this partner on the challenge website. "
              )
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("website"),
                  expression: "errors.has('website')"
                }
              ],
              staticClass: "col-sm-9 col-sm-offset-3 help-block is-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("website")) + " ")]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "form-group",
          class: { "has-error": _vm.errors.first("logo") }
        },
        [
          _c(
            "label",
            {
              staticClass: "col-sm-3 control-label",
              attrs: { for: "partner-logo-file" }
            },
            [_vm._v("Logo")]
          ),
          _c("div", { staticClass: "col-sm-9" }, [
            _c("div", { staticClass: "logo-field" }, [
              _vm.logoPreviewSrc && !_vm.logoPreviewError
                ? _c("div", { staticClass: "logo-field__preview-col" }, [
                    _c("img", {
                      staticClass: "logo-field__preview",
                      attrs: { src: _vm.logoPreviewSrc, alt: "Logo preview" },
                      on: {
                        error: function($event) {
                          _vm.logoPreviewError = true
                        }
                      }
                    }),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link btn-xs text-danger",
                        attrs: { type: "button" },
                        on: { click: _vm.removeLogo }
                      },
                      [
                        _c("i", { staticClass: "fa fa-times" }),
                        _vm._v(" Remove logo ")
                      ]
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "logo-field__controls" }, [
                _c("div", { staticClass: "logo-field__option" }, [
                  _c("span", { staticClass: "logo-field__option-label" }, [
                    _vm._v("Upload a new logo")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "mimes:image/png|size:2048",
                        expression: "'mimes:image/png|size:2048'"
                      }
                    ],
                    attrs: {
                      type: "file",
                      id: "partner-logo-file",
                      name: "logo",
                      accept: "image/png"
                    },
                    on: { change: _vm.onLogoSelected }
                  }),
                  _vm._m(0)
                ]),
                _vm._m(1),
                _c("div", { staticClass: "logo-field__option" }, [
                  _c("span", { staticClass: "logo-field__option-label" }, [
                    _vm._v("Or reuse an existing shared logo by filename")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.logo_filename,
                        expression: "form.logo_filename"
                      }
                    ],
                    staticClass: "form-control input-sm",
                    attrs: {
                      type: "text",
                      id: "partner-logo",
                      autocomplete: "off",
                      placeholder: "e.g. english_hubs.png"
                    },
                    domProps: { value: _vm.form.logo_filename },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "logo_filename", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ])
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("logo"),
                  expression: "errors.has('logo')"
                }
              ],
              staticClass: "col-sm-9 col-sm-offset-3 help-block is-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("logo")) + " ")]
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "box-footer" },
        [
          _c(
            "loading-button",
            { attrs: { type: "submit", isLoading: _vm.isLoading } },
            [_vm._v(_vm._s(_vm.submitLabel))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "help-block text-muted" }, [
      _vm._v(" PNG only (SVGs handled by the dev team). Trimmed, compressed ("),
      _c(
        "a",
        {
          attrs: {
            href: "https://tinypng.com",
            target: "_blank",
            rel: "noopener"
          }
        },
        [_vm._v("tinypng.com")]
      ),
      _vm._v(") and no larger than 1024×1024px. ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-field__divider" }, [
      _c("span", [_vm._v("or")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }